import React, { useState } from 'react';
import styles from './style.module.css';

import graphGroup from '../../assets/img/grafik-detailfasilitas.png';
import { Button, LoadingSpinner } from '../../components/elements';
import { DashboardLayout } from '../../components/layouts';

export default function DetailFacilityDashboard(props) {
  const [loading, setLoading] = useState(false);

  return (
    <DashboardLayout>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.root}>
          <h1 className={styles.pageTitle}>Detail Fasilitas</h1>
          <h3 className={styles.pageSubtitle}>Nama Fasilitas</h3>

          <div className={styles.detailContent}>
            <div className={styles.imageWrapper}>
              <img className={styles.graphGroup} src={graphGroup} alt=" " />
            </div>
            <div className={styles.clearfix}>
              <Button
                label="Lihat Kuesioner"
                color="primary"
                type="link"
                href="/questionnaire"
                className={styles.btnLook}
              />
              <Button
                label="Edit Kuesioner"
                color="secondary"
                type="link"
                href="/questionnaire"
                className={styles.btnEdit}
              />
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
